import { useTranslation } from "react-i18next";
import React from "react";
import { ApiInternal } from "src/api/api_internal";
import { UUID } from "src/api/api_common";
import { ConfirmDialog } from "src/components/base/confirm-dialog";

/**
 * The properties for {@link DeleteExtraRecordDialog}
 */
export type DeleteExtraRecordDialogProps = {
    /** The uuid of the record */
    record: UUID | undefined;
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback function when the Dialog is closed */
    onClose: () => void;
    /** Callback function when the file is deleted */
    onDelete: () => void;
};

/**
 * A dialog to delete a split-dns extra record.
 */
export default function DeleteExtraRecordDialog(props: DeleteExtraRecordDialogProps) {
    const [t] = useTranslation("dialog-delete-extra-record");

    if (!props.record) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.record) return;
                await ApiInternal.dns.deleteExtraDnsRecord(props.record);
                props.onDelete();
            }}
            title={t("heading.delete-extra-record")}
            confirmLabel={t("button.delete")}
            cancelLabel={t("button.cancel")}
        />
    );
}
